import React from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import DatePicker from 'react-datepicker';
import classNames from 'classnames';
import SubtleBadge from 'components/common/SubtleBadge';
import { Spinner } from 'react-bootstrap';

const columns = [
  {
    accessorKey: 'date',
    header: 'Date',
    accessorFn: row => {
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(row.date));
    },
    meta: {
      headerProps: { className: 'white-space-nowrap text-900 ps-0' },
      cellProps: { className: 'font-sans-serif white-space-nowrap fs-10 ps-0' },
    },
  },
  {
    accessorKey: 'nfact',
    header: 'Numéro vente',
    meta: {
      headerProps: { className: 'white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap fs-10' },
    },
  },
  {
    accessorKey: 'client',
    header: 'Client',
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: 'ps-2 text-start w-5 fw-semibold fs-10 white-space-nowrap',
      },
    },
  },
  {
    accessorKey: 'mntdtfin',
    header: 'Montant',
    meta: {
      headerProps: { className: 'text-end text-900 ' },
      cellProps: {
        className: 'ps-2 text-end w-5 fw-semibold fs-10',
      },
    },
  },
];

const FacturesVentes = ({ ventes, loading }) => {
  const table = useAdvanceTable({
    data: ventes,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 100,
    selectionColumnWidth: 52,
  });

  return loading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
      <Spinner animation="border" variant="primary" />
    </div>
  ) : (
    <AdvanceTableProvider {...table}>
      <AdvanceTable />
      <AdvanceTableFooter rowInfo navButtons />
    </AdvanceTableProvider>
  );
};

export default FacturesVentes;
